import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { AdresseFacadeService } from "./adresse-facade.service";
import { Adresse } from "../../models/adresse.model";

@Injectable({ providedIn: "root" })
export class AdresseStoreService extends EntityStoreService<
  Adresse,
  EntityMetadata,
  AdresseState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface AdresseState extends EntityStoreState<AdresseFacadeService> {}
